import { urls } from '~/preloaded';
import { get, post } from '~/helpers/api';

import type { PoshtaMarker } from '~/types/poshta';

const URL = urls.poshta;

const API_VERSION = 'v1';
const API_ENDPOINTS = {
  MARKERS: `/api/${API_VERSION}/markers/?tag=clans`,
  MARKERS_DEACTIVATE: `/api/${API_VERSION}/markers/deactivate/`,
};

export enum POSHTA_RESPONSE_STATUS {
  OK = 'OK',
}

interface ApiPoshtaErrorDetailMessage {
  loc: [string, number];
  msg: string;
  type: string;
}

interface ApiPoshtaError {
  detail: string | ApiPoshtaErrorDetailMessage[];
}

type ApiPoshtaMarkersResponse = {
  result: PoshtaMarker[];
};

export const fetchPoshtaMarkers = async (signal?: AbortSignal) => {
  if (!URL) {
    return null;
  }

  const url = `${URL}${API_ENDPOINTS.MARKERS}`;
  return await get<ApiPoshtaMarkersResponse, ApiPoshtaError>(url, {}, signal && { signal });
};

type ApiPoshtaMarkersDeactivateResponse = { status: POSHTA_RESPONSE_STATUS };

export const deactivatePoshtaMarkers = async (requestId: string, markerIds: string[]) => {
  if (!URL) {
    return null;
  }

  const url = `${URL}${API_ENDPOINTS.MARKERS_DEACTIVATE}`;
  return await post<ApiPoshtaMarkersDeactivateResponse, ApiPoshtaError>(url, { requestId, markerIds });
};
